// extracted by mini-css-extract-plugin
export var actions = "_4g-5";
export var editor = "_4g-0";
export var error = "_4g-4";
export var source = "_4g-1";
export var textarea = "_4g-2";
export var textareaError = "_4g-3";